import { useState } from 'react';
import { Button, Input } from '@monigo/ui';

interface NameCellProps {
  name: string | null;
  email: string;
  canEdit: boolean;
  onSave: (name: string) => void;
}

export function NameCell({ name, email, canEdit, onSave }: NameCellProps) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(name ?? '');

  if (!canEdit) {
    return (
      <div>
        {name ?? <span className="text-text-muted italic">No name</span>}
        <span className="ml-2 text-xs text-text-muted">{email}</span>
      </div>
    );
  }

  if (editing) {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSave(draft);
          setEditing(false);
        }}
        className="flex items-center gap-1"
      >
        <Input
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          className="h-9 w-44 text-sm"
          autoFocus
          placeholder="Display name"
        />
        <Button type="submit" size="sm" variant="ghost">
          ✓
        </Button>
        <Button type="button" size="sm" variant="ghost" onClick={() => setEditing(false)}>
          ✕
        </Button>
      </form>
    );
  }

  return (
    <div>
      <button
        type="button"
        onClick={() => {
          setDraft(name ?? '');
          setEditing(true);
        }}
        className="text-left hover:underline"
      >
        {name ?? <span className="text-text-muted italic">No name</span>}
      </button>
      <span className="ml-2 text-xs text-text-muted">{email}</span>
    </div>
  );
}
